import { createSlice } from "@reduxjs/toolkit";
import { AppThunk } from "./app";
import api from "./api";
import API_URL from "../config/ApiUrl";

const DashboardSlice = createSlice({
  name: "DASHBOARD",
  initialState: null,
  reducers: {},
});

export const getDailyReport =
  (action: any): AppThunk<any> =>
  async (dispatch) => {
    try {
      const response = await api.post(API_URL.DASHBOARD.DAILY_REPORT, action);
      return Promise.resolve(response.data);
    } catch (error: any) {
      return Promise.reject(error.data);
    }
  };

export default DashboardSlice.reducer;
